/**
 * /industrie/aides — Hub des aides aux sites industriels & grandes entreprises
 *
 * Liste les 5 dispositifs mobilisables (CEE IND, Coups de pouce industriels,
 * Fonds chaleur ADEME, Fonds décarbonation industrie, prêts Bpifrance climat).
 * Chaque carte renvoie vers la page éditoriale dédiée
 * `/industrie/aides/[slug]`.
 *
 * Composant générique tone-aware (CORPORATE) :
 *   AudienceAidesHub
 */

import { AudienceAidesHub } from '../../../components/aides/AudienceAidesHub';
import { AIDES_INDUSTRIE } from '../../../config/aides-industrie';

export default function IndustrieAidesHubPage() {
  return (
    <AudienceAidesHub
      audienceId="industrie"
      aides={AIDES_INDUSTRIE}
      heroEyebrow="Panorama 2026 · 7 leviers cumulables"
      heroHeadline="Toutes vos aides"
      heroHeadlineAccent="pour décarboner votre site"
      heroIntro="Primes CEE industrielles sur les utilités et le bâti (familles IND-UT et IND-BA), Coups de pouce industriels, Fonds chaleur de l'ADEME, Fonds décarbonation industrie et prêts Bpifrance climat : cinq leviers cumulables qui financent une part significative des investissements d'efficacité énergétique de votre site."
      primaryCta={{ label: 'Diagnostic primes énergie industrielles', href: '/industrie/diagnostic-cee' }}
      secondaryCta={{ label: 'Catalogue fiches industrie', href: '/cee/fiches?secteur=IND' }}
      bullets={['Sources officielles citées', 'Accord de confidentialité disponible', 'Aides 2026 à jour']}
      gridEyebrow="7 leviers de financement et d'économies"
      gridTitle="Les aides disponibles pour les industriels"
      ctaFinalTitle="Quel potentiel CEE pour votre site ?"
      ctaFinalDescription="On identifie les opérations éligibles sur vos utilités et votre bâti industriel (fiches IND-UT et IND-BA), on vérifie les Coups de pouce du moment et on regarde si le Fonds chaleur ADEME et le Fonds décarbonation peuvent se cumuler."
    />
  );
}
